import { Service } from '@/shared/api/protocol-ts/api/billing_new/dto_services_new_pb';

import { HIDDEN_SERVICES } from '../config';

const isServiceDisplayed = (service: Service) =>
  service.Visible && !HIDDEN_SERVICES.includes(service.Types[0]);

export const getDisplayedServices = (services: Service[]) =>
  services.filter(isServiceDisplayed);
